import React, { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';


export const initialValues = { isModalOpen: false, open: modalProps => { }, close: () => { }, modalProps: {} };
export const WaitingListContext = createContext(initialValues);

export const WaitingListProvider = ({ children }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalProps, setModalProps] = useState({});

  const open = modalProps => {
    setIsModalOpen(true);
    setModalProps(modalProps);
  };

  const close = () => {
    setIsModalOpen(false);
    setModalProps({});
  };
  return (
    <WaitingListContext.Provider value={{ isModalOpen, open, close, modalProps }}>
      {children}
    </WaitingListContext.Provider>
  );
};
WaitingListProvider.propTypes = {
  children: PropTypes.any
};
export const useWaitingList = () => useContext(WaitingListContext);
